import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../services/firebaseConfig";
import { menuStyles } from "../../theme/theme";
import CloseButton from "../closeButton/CloseButton";
import { AuthContext } from "../../services/context/authContext/AuthContext";
import { OrderContext } from "../../services/context/orderContext/OrderContext";
import jsonData from "../../../package.json";

const DrawerMenu = (props) => {
  const user = useContext(AuthContext);
  const orderContext = useContext(OrderContext);
  const isAdmin = user?.role === "admin";
  const { toggle, showMenu } = props;
  const navigate = useNavigate();
  useEffect(() => {
    if (!showMenu) {
      document.body.setAttribute("style", "overflow:hidden");
    }
    showMenu && document.body.setAttribute("style", "overflow:unset");
  }, [showMenu]);
  return (
    <>
      <div
        className={!showMenu ? "overlay" : "overlay-hide"}
        onClick={toggle}
      />
      <div
        className={showMenu ? menuStyles["menuShow"] : menuStyles["menuHide"]}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <CloseButton
          className="mt-11 right-9 tablet:mt-16"
          currentColor="black"
          onClick={toggle}
        />
        <div className="flex flex-col justify-between h-full ">
          <div className="flex flex-col items-start ">
            <p className="mb-16   mt-28 xl:mt-52 tablet:mt-36 cursor-pointer text-txtGray font-medium text-base tablet:text-lg">
              Menu
            </p>
            {isAdmin ? (
              <Link
                onClick={toggle}
                className="mb-9 cursor-pointer text-txtBlack font-bold text-xl"
                to="/users"
              >
                Users
              </Link>
            ) : (
              <Link
                onClick={toggle}
                className="mb-9 cursor-pointer text-txtBlack font-bold text-xl"
                to="/my-account"
              >
                Account
              </Link>
            )}
            <Link
              onClick={toggle}
              className="mb-9 cursor-pointer text-txtBlack font-bold text-xl"
              to="/orders"
            >
              Orders
            </Link>
            {isAdmin ? (
              <Link
                onClick={toggle}
                className="xl:mb-28 mb-16 cursor-pointer text-txtBlack font-bold text-xl"
                to="/settings"
              >
                Settings
              </Link>
            ) : (
              <Link
                onClick={toggle}
                className="xl:mb-28 mb-16 cursor-pointer text-txtBlack font-bold text-xl"
                to="/help"
              >
                Help
              </Link>
            )}
            <p
              className=" cursor-pointer text-txtBlack font-bold text-xl"
              onClick={() => {
                auth.signOut().catch((err) => console.log(err));
                orderContext.updateOrder([]);
                toggle();
                navigate("/");
              }}
            >
              Log out
            </p>
          </div>
          <div className=" pb-14 tablet:pb-20 mt-10">
            <p className="mb-8 text-txtGray font-medium text-base tablet:text-lg">
              Contact
            </p>
            <p className="mb-2.5 text-base font-medium text-txtBlack">
              {`+1  (773) 627-1411`}
            </p>
            <p className="text-base font-medium text-txtBlack">
              office@g7studios.com
            </p>
          </div>

          <span className="absolute bottom-1 [left:280px] [color:grey]">
            {"Version ".concat(jsonData.version)}
          </span>
        </div>
      </div>
    </>
  );
};

export default DrawerMenu;
